'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rcTouchable = require('rc-touchable');

var _rcTouchable2 = _interopRequireDefault(_rcTouchable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var InputHandler = function (_Component) {
  (0, _inherits3['default'])(InputHandler, _Component);

  function InputHandler() {
    (0, _classCallCheck3['default'])(this, InputHandler);
    return (0, _possibleConstructorReturn3['default'])(this, (InputHandler.__proto__ || Object.getPrototypeOf(InputHandler)).apply(this, arguments));
  }

  (0, _createClass3['default'])(InputHandler, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          disabled = _props.disabled,
          otherProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'disabled']);

      return _react2['default'].createElement(
        _rcTouchable2['default'],
        { disabled: disabled, activeClassName: prefixCls + '-handler-active' },
        _react2['default'].createElement('span', otherProps)
      );
    }
  }]);
  return InputHandler;
}(_react.Component);

InputHandler.propTypes = {
  prefixCls: _propTypes2['default'].string,
  disabled: _propTypes2['default'].bool
};

exports['default'] = InputHandler;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-input-number/lib/InputHandler.js
// module id = 1178
// module chunks = 0